import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import AdvanceInventory from "./productPages/AdvanceInventory";
import LiteBilling from "./productPages/LiteBilling";
import PosBasic from "./productPages/PosBasic";
import SpecialBilling from "./productPages/SpecialBilling";
import "./reports.scss";

const productReportMapping = {
  "Basic POS": PosBasic,
  "Special Billing": SpecialBilling,
  "Lite Billing": LiteBilling,
  "Advance Inventory": AdvanceInventory,
};

const getStoredReportContext = () => {
  try {
    const stored = sessionStorage.getItem("selectedProductReport");
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error("Unable to read selected report context:", error);
    return null;
  }
};

const ReportDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const reportContext = useMemo(
    () => location.state?.reportContext || getStoredReportContext(),
    [location.state],
  );

  const ReportComponent = reportContext
    ? productReportMapping[reportContext.productName]
    : null;

  return (
    <div className="list reports-page report-details-page">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <div className="reports-content">
          <div className="reports-header">
            <div>
              <h1>Reports</h1>
              <p>
                {reportContext
                  ? `${reportContext.businessName} / ${reportContext.productName}`
                  : "No product report selected."}
              </p>
            </div>
            <button
              type="button"
              className="reports-back-btn"
              onClick={() => navigate("/config/reports")}
            >
              Back to Reports
            </button>
          </div>

          {ReportComponent ? (
            <ReportComponent reportContext={reportContext} />
          ) : (
            <div className="reports-placeholder">
              <h3>{reportContext?.productName || "Select a product report"}</h3>
              <p>
                {reportContext
                  ? "Report mapper is not configured for this product yet."
                  : "Go back to Reports and choose a product row."}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;
